import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Home from '../home/Home';
import OwnedVehiclePage from '../owned-vehicle-page/OwnedVehiclePage';
import Header from '../_common/header/Header';
import Footer from '../_common/footer/Footer';

export default function Routes() {
  return (
    <>
      <Header />
      {/* NOTE(2024/02): these components are strictly for local development and should be removed. */}
      {/* <AccountModal /> */}
      {/* <OneTimePasswordModal /> */}
      <Switch>
        <Route path="/my-carvana" exact component={Home} />
        <Route path="/my-carvana/vehicle/:params" component={OwnedVehiclePage} />
        <Route path="/" render={() => <Redirect to="/my-carvana" />} />
      </Switch>
      <Footer />
    </>
  );
}
